<template>
  <div>
  </div>
</template>

<script>

export default {
  name: 'MitMenu',
  components: {
  },
  props: {
    userModel: Object
  }
}
</script>

<style lang="scss" scoped>
</style>
